// src/api/authApi.js — Auth (login / me)

import { api, tokenStorage } from './apiClient';

export async function login(telefono, password) {
  // El backend espera Telefono en E.164, no correo. Ver LoginRequestDto.
  const res = await api.post('/api/holaveci/auth/login', { telefono, password }, { skipAuth: true });
  tokenStorage.set(res.token);
  return res;   // { token, entidadTipo, entidadId, correo, nombre, correoVerificado }
}

export async function me() {
  return await api.get('/api/holaveci/auth/me');
}

export async function logout() {
  try { await api.post('/api/holaveci/auth/logout', {}); } catch { /* ignore */ }
  tokenStorage.clear();
}

// Reset password (2 pasos)
export async function solicitarReset(correo) {
  return await api.post('/api/holaveci/auth/solicitar-reset', { correo }, { skipAuth: true });
}

export async function confirmarReset(userId, token, passwordNueva) {
  return await api.post('/api/holaveci/auth/confirmar-reset',
    { userId, token, passwordNueva }, { skipAuth: true });
}

// Init (setup inicial de la plataforma — se llama una vez tras el deploy)
export const admin = {
  initRoles:      () => api.post('/api/holaveci/admin/init/roles',     {}, { skipAuth: true }),
  initSuperAdmin: () => api.post('/api/holaveci/admin/init/superadmin',{}, { skipAuth: true }),

  // Usuarios
  usuariosListar:  (params)     => api.get('/api/holaveci/admin/usuarios',        { query: params }),
  usuarioDetalle:  (id)         => api.get(`/api/holaveci/admin/usuarios/${id}`),
  usuarioCrear:    (payload)    => api.post('/api/holaveci/admin/usuarios', payload),
  usuarioEliminar: (id, forzar = false) =>
    api.delete(`/api/holaveci/admin/usuarios/${id}`, { query: forzar ? { forzar: true } : undefined }),
  usuarioBloquear:   (id)       => api.patch(`/api/holaveci/admin/usuarios/${id}/bloquear`, {}),
  usuarioDesbloquear:(id)       => api.patch(`/api/holaveci/admin/usuarios/${id}/desbloquear`, {}),
  usuarioConfirmarCorreo:(id)   => api.patch(`/api/holaveci/admin/usuarios/${id}/confirmar-correo`, {}),
  /** Asigna una contraseña nueva a cualquier usuario (soporte). Cierra sus sesiones. */
  usuarioCambiarPassword: (id, password) =>
    api.patch(`/api/holaveci/admin/usuarios/${id}/password`, { password }),
  usuarioAsignarRol: (id, rol)  => api.post(`/api/holaveci/admin/usuarios/${id}/roles/${rol}`, {}),
  usuarioQuitarRol:  (id, rol)  => api.delete(`/api/holaveci/admin/usuarios/${id}/roles/${rol}`),

  // Negocios (Tenants)
  negociosListar: (params)      => api.get('/api/holaveci/admin/negocios',        { query: params }),
  negocioDetalle: (id)          => api.get(`/api/holaveci/admin/negocios/${id}`),
  negocioSuspender: (id, motivo)=> api.patch(`/api/holaveci/admin/negocios/${id}/suspender`, { motivo }),
  negocioReactivar: (id)        => api.patch(`/api/holaveci/admin/negocios/${id}/reactivar`, {}),
  negocioAprobar:   (id)        => api.patch(`/api/holaveci/admin/negocios/${id}/aprobar`, {}),
  /** D-26: activa un negocio sin que medie pago (cuentas demo). Queda auditado. */
  negocioActivarSinPago: (id, { motivo, exentaDeCobro = false, planCodigo = null }) =>
    api.post(`/api/holaveci/admin/negocios/${id}/activar-sin-pago`, { motivo, exentaDeCobro, planCodigo }),
  negocioReanudarCobro:  (id, motivo) =>
    api.post(`/api/holaveci/admin/negocios/${id}/reanudar-cobro`, { motivo }),
  negocioAuditoriaCobro: (id) => api.get(`/api/holaveci/admin/negocios/${id}/auditoria-cobro`),
  negocioRechazar:  (id, motivo)=> api.patch(`/api/holaveci/admin/negocios/${id}/rechazar`, { motivo }),

  // Vecis
  vecisListar:    (params)      => api.get('/api/holaveci/admin/vecis',           { query: params }),
  veciDetalle:    (id)          => api.get(`/api/holaveci/admin/vecis/${id}`),

  // Auditoría transversal (D-27) — solo lectura
  auditoriaListar:     (params) => api.get('/api/holaveci/admin/auditoria', { query: params }),
  auditoriaDetalle:    (id)     => api.get(`/api/holaveci/admin/auditoria/${id}`),
  auditoriaFacetas:    (dias)   => api.get('/api/holaveci/admin/auditoria/facetas', { query: dias ? { dias } : undefined }),
  /** Historial de una entidad concreta: "¿qué le hicieron a este usuario?" */
  auditoriaPorEntidad: (entidad, entidadId, limite) =>
    api.get(`/api/holaveci/admin/auditoria/entidad/${encodeURIComponent(entidad)}/${encodeURIComponent(entidadId)}`,
      { query: limite ? { limite } : undefined }),

  // Secretos cifrados con Cloud KMS (Tanda 2B pagos)
  secretosListar:   ()          => api.get('/api/holaveci/admin/secretos'),
  secretosGuardar:  (payload)   => api.post('/api/holaveci/admin/secretos', payload),
  secretosEliminar: (codigo)    => api.delete(`/api/holaveci/admin/secretos/${encodeURIComponent(codigo)}`),
};

// Validación manual de documentos (D-18) — rol VALIDADOR o SUPERADMIN
export const validacion = {
  pendientes:         ()               => api.get('/api/holaveci/admin-validacion/pendientes'),
  empresaDetalle:     (id)             => api.get(`/api/holaveci/admin-validacion/empresa/${id}`),
  documentoAprobar:   (documentoId)    => api.post('/api/holaveci/admin-validacion/documento/aprobar', { documentoId }),
  documentoRechazar:  (documentoId, motivo) =>
    api.post('/api/holaveci/admin-validacion/documento/rechazar', { documentoId, motivo }),
  consultaPortal:     (payload)        => api.post('/api/holaveci/admin-validacion/consulta-portal', payload),
  negocioAprobar:     (empresaId)      => api.post(`/api/holaveci/admin-validacion/empresa/${empresaId}/aprobar`, {}),
  negocioRechazar:    (empresaId, motivo) =>
    api.post(`/api/holaveci/admin-validacion/empresa/${empresaId}/rechazar`, { motivo }),
  guiasDisponibles: (q) => {
    const qs = q ? `?q=${encodeURIComponent(q)}` : '';
    return api.get(`/api/holaveci/admin-validacion/guias-disponibles${qs}`);
  },
  asignarGuia: (empresaId, guiaId, motivo) =>
    api.post(`/api/holaveci/admin-validacion/empresa/${empresaId}/asignar-guia`,
      { guiaId, motivo }),
};

// Moderación de mensajes de chat (D-19) — rol ADMIN_SISTEMA o SOPORTE_HOLAVECI
export const moderacion = {
  listar: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.severidad != null) qs.set('severidad', params.severidad);
    if (params.tipoChat) qs.set('tipoChat', params.tipoChat);
    if (params.desdeDias != null) qs.set('desdeDias', params.desdeDias);
    if (params.soloBloqueados) qs.set('soloBloqueados', 'true');
    const q = qs.toString();
    return api.get(`/api/holaveci/admin-moderacion/intentos${q ? `?${q}` : ''}`);
  },
  marcarFalsoPositivo: (id) =>
    api.post(`/api/holaveci/admin-moderacion/intentos/${id}/marcar-falso-positivo`, {}),
  guardarNotas: (id, notas) =>
    api.post(`/api/holaveci/admin-moderacion/intentos/${id}/notas`, { notas }),
};
